var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "71px",
    height: "40.853px",
    viewBox: "0 0 71 40.853",
    enableBackground: "new 0 0 71 40.853",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 71,
    height: 40.853
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M59.934,9.555C51.813,3.308,43.394,0,35.5,0C16.63,0,1.759,18.238,1.135,19.013L0,20.426 l1.135,1.414c2.959,3.502,6.289,6.673,9.931,9.457c8.12,6.248,16.539,9.556,24.434,9.556c18.87,0,33.74-18.239,34.364-19.013 L71,20.426l-1.136-1.413C66.905,15.511,63.575,12.34,59.934,9.555 M35.5,37.624c-14.948,0-27.914-12.729-32-17.198 c4.062-4.468,17.02-17.198,32-17.198s27.913,12.73,32,17.198C63.422,24.902,50.48,37.624,35.5,37.624"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M35.312,7.256C28.038,7.36,22.226,13.34,22.33,20.613c0.104,7.274,6.085,13.086,13.358,12.982 c7.2-0.102,12.984-5.967,12.984-13.168C48.613,13.103,42.636,7.21,35.312,7.256 M35.284,30.366 c-5.506-0.12-9.872-4.681-9.753-10.186c0.12-5.505,4.681-9.873,10.186-9.752c5.434,0.118,9.773,4.566,9.755,10 c-0.067,5.565-4.624,10.025-10.188,9.972V30.366z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsights);
export default __webpack_public_path__ + "static/media/icon-insights.e33808930eae68876a21eaa56b00fc48.svg";
export { ForwardRef as ReactComponent };